import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { RotateCcw, Trash2, ChevronDown } from "lucide-react";
import { toast } from "sonner";

const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86400000));

export const RecentlyDeleted = ({ refreshKey, onRestored }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/admin/deleted-explorers").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  const restore = async (r) => {
    try { const { data } = await api.post(`/admin/deleted-explorers/${r.id}/restore`); toast.success(`${data.child_name} restored${data.parent_linked ? "" : " — parent account is gone, link a parent"}`); load(); onRestored(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  if (!rows.length) return null;
  return (
    <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50" data-testid="recently-deleted">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-3 py-2 text-sm font-semibold text-slate-600" data-testid="recently-deleted-toggle">
        <span className="flex items-center gap-2"><Trash2 className="w-4 h-4" />Recently deleted ({rows.length})</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2">
          <p className="text-[11px] text-slate-400">Deleted explorers are kept for 30 days, then removed for good.</p>
          {rows.map((r) => (
            <div key={r.id} className="flex items-center justify-between gap-2 bg-white rounded-lg border border-slate-200 px-3 py-2" data-testid={`deleted-row-${r.id}`}>
              <div>
                <p className="text-sm font-semibold text-navy">{r.child_name} <span className="font-mono text-[11px] text-slate-400">{r.explorer_id}</span></p>
                <p className="text-[11px] text-slate-400">{r.parent_name ? `${r.parent_name} · ` : ""}deleted {new Date(r.deleted_at).toLocaleDateString("en", { month: "short", day: "numeric" })}{r.deleted_by ? ` by ${r.deleted_by}` : ""} · {daysLeft(r.purge_after)} days left</p>
              </div>
              <Button size="sm" variant="outline" onClick={() => restore(r)} className="rounded-full h-8 text-turquoise border-turquoise/40" data-testid={`restore-${r.id}`}><RotateCcw className="w-3.5 h-3.5 mr-1" />Restore</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
